<template>
  <div>
    <section v-if="content.body.length">
      <div class="mb-2 pt-5">
        <div class="d-flex">
          <div class="flex-grow-1">
            <div class="headline" v-text="content.title"></div>
          </div>
          <template>
            <div class="flex-shrink-1">
              <v-btn
                class="text-capitalize"
                text
                :color="$buttonColor"
                @click="more()"
              >
                <!-- {{ $vuetify.lang.t("$vuetify.actions.more") }} -->
                See More
                <v-icon right small>far fa-chevron-right</v-icon>
              </v-btn>
            </div>
          </template>
        </div>
        <div
          class="subtitle-1 grey--text text--darken-2"
          v-text="content.subtitle"
        ></div>
      </div>
      <template v-if="!gridMode">
        <v-slide-group v-model="selected" :show-arrows="true">
          <v-slide-item
            v-for="(item, idx) of content.body"
            :key="`cat_${idx}`"
            v-slot:default="{ active, toggle }"
          >
            <v-hover v-slot:default="{ hover }">
              <v-sheet
                class="text-center hoverable card-growable pt-4"
                :min-height="iconHeight + 48"
                :width="200"
                @click="navigate(item)"
              >
                <v-avatar :class="['grey lighten-3']" :size="iconHeight">
                  <v-img
                    :max-height="iconHeight"
                    contain
                    :src="item.image"
                    :lazy-src="item.image"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>

                <div
                  :class="{ 'primary--text': hover || active }"
                  class="font-weight-bold subtitle-1 text-center mt-3 text-overflow"
                  v-text="item.displayName"
                ></div>
              </v-sheet>
            </v-hover>
          </v-slide-item>
        </v-slide-group>

        <v-expand-transition>
          <v-sheet
            class="mt-4"
            v-if="selected != null"
            color="grey lighten-4"
            elevation="0"
          >
            <div class="pa-4 pb-2">
              <div
                class="subtitle-1 mb-2 font-weight-bold"
                v-text="selectedTeacher.displayName || ''"
              ></div>
              <div
                class="body-1 mb-4"
                v-text="selectedTeacher.description || ''"
              ></div>
              <v-item-group>
                <v-row>
                  <v-col class="grow">
                    <v-btn
                      :color="$buttonColor"
                      class="white--text"
                      @click="navigate()"
                    >
                      <v-icon left>fal fa-address-card</v-icon>More Info
                    </v-btn>
                  </v-col>
                  <v-col class="shrink">
                    <v-btn outlined @click="selected = null">Dismiss</v-btn>
                  </v-col>
                </v-row>
              </v-item-group>
            </div>
          </v-sheet>
        </v-expand-transition>
      </template>

      <template v-if="gridMode">
        <div>grid-mode</div>
      </template>
      <template v-if="content.footerButton != null">
        <div class="mt-3">
          <v-btn :color="$buttonColor">
            <!-- {{ $vuetify.lang.t("$vuetify.actions.more") }} -->
            {{ content.footerButton.title }}
            <v-icon right small>far fa-chevron-right</v-icon>
          </v-btn>
        </div>
      </template>
    </section>
    <section v-else>
      <div class="mb-2 pt-5">
        <div class="d-flex">
          <div class="flex-grow-1">
            <div class="headline" v-text="content.title"></div>
          </div>
        </div>
        <div
          class="subtitle-1 grey--text text--darken-2"
          v-text="content.subtitle"
        ></div>
      </div>
      <v-row class="px-2 mb-4 text-center body-2 grey--text">
        <v-col cols="12"> ไม่มีข้อมูล </v-col>
      </v-row>
    </section>
  </div>
</template>

<script>
export default {
  name: "teacher_horizontal_listview",
  props: ["content", "gridView"],
  data: () => ({
    selected: null,
    iconHeight: 72,
  }),
  computed: {
    gridMode() {
      let result = false;

      if (this.gridView == null) {
        result = false;
      } else {
        result = true;
        // if (this.gridView == true) {
        //   result = true;
        // } else {
        //   result = false;
        // }
      }
      return result;
    },
    selectedTeacher() {
      if (this.selected != null) {
        return this.content.body[this.selected];
      }
      return null;
    },
  },
  mounted() {
    // console.log(this.content);
  },
  methods: {
    more() {
      // const qs = this.$utility.queryStringToJson(
      //   this.content.headerButton.queries
      // );
      const qs = this.content.footerButton
        ? this.content.footerButton.queries
        : this.content.headerButton.queries;
      let sorting = qs.filter((query) => query.param == "sort")[0].value;
      let sortingby = qs.filter((query) => query.param == "sortby")[0].value;
      let searching = qs.filter((query) => query.param == "search")[0];
      if (searching) {
        searching = searching.value;
      } else {
        searching = null;
      }
      this.$router.push({
        name: "instructors",
        query: {
          sort: sorting,
          sortby: sortingby,
          page: 1,
          limit: 10,
          title: this.content.title,
          search: searching,
        },
      });
    },
    navigate(item) {
      this.$router.push({
        name: "instructor",
        params: {
          id: item._id,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.card-growable {
  background-color: unset;
}
</style>